import { render, staticRenderFns } from "./termModal.vue?vue&type=template&id=3904b3ce&lang=pug&"
import script from "./termModal.vue?vue&type=script&lang=js&"
export * from "./termModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3904b3ce')) {
      api.createRecord('3904b3ce', component.options)
    } else {
      api.reload('3904b3ce', component.options)
    }
    module.hot.accept("./termModal.vue?vue&type=template&id=3904b3ce&lang=pug&", function () {
      api.rerender('3904b3ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/components/dashboard/termModal.vue"
export default component.exports